import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Checks a flat "resource:action" permission key against the array every
 * login flow stores in AuthContext.permissions (see auth.provider.tsx /
 * login, mfa-verify, activate). System admins always pass.
 */
export const usePermission = (permission: string): boolean => {
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  if (isSystemAdmin === 'true' || isSystemAdmin === true) return true;

  const flatPermissions = Array.isArray(permissions) ? (permissions as unknown as string[]) : null;
  return flatPermissions?.includes(permission) ?? false;
};
